var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sbtn"},[_c('button',{staticClass:"transition-colors duration-500 ease-in-out text-primary bg-white hover:bg-primary hover:text-white",on:{"click":function($event){return _vm.open()}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }